<rc-order [isSuccessful]="true">
  <span order-heading>
    <div class="success-header">
      <div class="success-icon-container">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <div class="success-animation"></div>
      </div>
      <h1 class="success-title">Comanda {{orderId ? '#' + orderId : ''}} plasată cu succes!</h1>
    </div>
  </span>

  <span order-content>
    <div class="success-content">
      <div class="payment-confirmation">
        <mat-icon class="check-icon">verified</mat-icon>
        <h2>Plata a fost confirmată cu succes</h2>
      </div>

      <div class="next-steps">
        <h3>Ce urmează?</h3>
        <div class="steps-container">
          <div class="step">
            <div class="step-icon">
              <mat-icon>phone</mat-icon>
            </div>
            <div class="step-content">
              <h4>Te vom contacta telefonic</h4>
              <p>În cel mai scurt timp, vei fi contactat pentru confirmarea și validarea comenzii</p>
              <small class="schedule">Program: Luni - Vineri, 9:00 - 17:00</small>
            </div>
          </div>

          <div class="step">
            <div class="step-icon">
              <mat-icon>email</mat-icon>
            </div>
            <div class="step-content">
              <h4>Vei primi detaliile pe e-mail</h4>
              <p>Detaliile comenzii și ale plății vor fi trimise pe adresa ta de e-mail</p>
            </div>
          </div>

          <div class="step">
            <div class="step-icon">
              <mat-icon>local_shipping</mat-icon>
            </div>
            <div class="step-content">
              <h4>Pregătim comanda</h4>
              <p>Echipa noastră va începe procesarea comenzii tale</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </span>

  <span thanks-content>
    <div class="thanks-section">
      <div class="thanks-message">
        <mat-icon class="heart-icon">favorite</mat-icon>
        <h2>Mulțumim că ai ales ExpertTabla.ro!</h2>
        <p>Apreciem încrederea acordată și ne angajăm să îți oferim produse de cea mai bună calitate.</p>
      </div>

      <div class="contact-info">
        <h3>Ai întrebări?</h3>
        <div class="contact-methods">
          <a [href]="'tel:' + phoneRaw" class="contact-item">
            <mat-icon>phone</mat-icon>
            <span>{{phone}}</span>
          </a>
          <a [href]="'mailto:' + email" class="contact-item">
            <mat-icon>email</mat-icon>
            <span>{{email}}</span>
          </a>
        </div>
      </div>
    </div>
  </span>

  <span thanks-heading>
    <!-- This content is now integrated above -->
  </span>
</rc-order>
